import { useState } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import SmallScreenBrand from "./small";
import LargeScreenBrand from "./large";

const HomePageTheBrandSection = () => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  return isSmallScreen ? (
    <SmallScreenBrand expanded={expanded} onToggle={() => setExpanded((e) => !e)} />
  ) : (
    <LargeScreenBrand expanded={expanded} onToggle={() => setExpanded((e) => !e)} />
  );
};

export default HomePageTheBrandSection;
